import {CheckIcon, ChevronIcon, Grid, Loader} from '@yandex-delivery/blocks'
import clsx from 'clsx'
import {memo} from 'react'

import {ExtraItem} from 'src/shared/components/desktop'
import {i18n} from 'src/shared/config'

import {ConfirmModal} from '../ConfirmModal/ConfirmModal'
import {DraggableRouteItems} from '../DraggableRouteItems/DraggableRouteItems'
import * as classes from './OptimizeRouteCustomModal.classes'
import type {Props} from './types'

export const OptimizeRouteCustomModal = memo<Props>(function OptimizeRouteCustomModal(props) {
  const {
    onDecline,
    onAccept,
    isOpen,
    destinationPoints,
    onDragEnd,
    sourcePoint,
    draftOptimizationState,
    routeOrder,
    onOptimize,
  } = props

  return (
    <ConfirmModal locale={locale} ModalProps={modalProps} onCancel={onDecline} onSubmit={onAccept} open={isOpen}>
      <DraggableRouteItems
        destinations={destinationPoints}
        onDragEnd={onDragEnd}
        sortOrder={routeOrder}
        source={sourcePoint}
      />
      {draftOptimizationState === 'idle' && (
        <ExtraItem
          className={classes.root}
          description={i18n('cargo.create.rout-change.shipping_could_get_cheaper', 'Доставка может стать дешевле')}
          onClick={onOptimize}
          title={i18n('cargo.create.rout-change.optimize_route_automatically', 'Оптимизировать маршрут автоматически')}
          clean
        >
          <ChevronIcon />
        </ExtraItem>
      )}
      {draftOptimizationState === 'completed' && (
        <Grid alignItems="center" className={clsx(classes.root, classes.completed)} container>
          <Grid className={classes.icon} item>
            <CheckIcon />
          </Grid>
          <Grid item xs>
            {i18n('cargo.create.rout-change.route_optimized', 'Маршрут оптимизирован')}
          </Grid>
        </Grid>
      )}
      {draftOptimizationState === 'pending' && (
        <Grid alignItems="center" className={classes.root} justify="center" container>
          <Grid className={classes.icon} item>
            <Loader />
          </Grid>
          <Grid item xs>
            {i18n('cargo.create.rout-change.route_optimization', 'Оптимизация маршрута')}
          </Grid>
        </Grid>
      )}
    </ConfirmModal>
  )
})

const modalProps = {
  className: classes.paper,
}
const locale = {
  title: i18n('cargo.create.rout-change.address_order', 'Порядок адресов'),
}
